// extracted by mini-css-extract-plugin
export default {"container":"Projects_container__-9eVi","projects":"Projects_projects__Mqq8x","project__swiper":"Projects_project__swiper__Nk8gZ","swiper__slide":"Projects_swiper__slide__qdIHS"};